import React from 'react';
import { styles } from './PrintFormStructure.styles';
import { PropTypes } from 'prop-types';
import FormValue, { lengthContent } from './FormValue';
import { renderFormValue } from './GetFormValue';

const GroupItem = ({ item, entry }) => {
    const value = renderFormValue(item, entry) || '-';
    const { column, isLong } = lengthContent(item?.label, value);
    const classes = styles({
        column,
        isLong
    });
    return (
        <div className={item.data_type === 'group' ? classes.groupContainer : classes.item}>
            <FormValue field={item} entry={entry} />
        </div>
    );
};
GroupItem.propTypes = {
    item: PropTypes.object,
    entry: PropTypes.object
};
export default GroupItem;
